import React, { useState } from "react";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { FormControl, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import ApiClient from "../../common/ApiClient";
import { useEffect } from "react";
import DeleteDialog from "../../ip/DeleteDialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useParams } from "react-router-dom";

import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { GLOBAL_URL } from "../../../API/global";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import Loader from "../../common/Loader/Loader";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { validatePdf } from "../../Helper";

// import Button from '@mui/material/Button';
// import DeleteIcon from '@mui/icons-material/Delete';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const PartialInfo = ({
  setFormDataMain,
  errors,
  FormDataMain,
  setProducerErrors,
}) => {
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const { id = null } = useParams();
  const { postRequest, getRequest, deleteRequest } = ApiClient();
  const [errorsForm, setErrorsForm] = useState({});
  const [preData, setPreData] = useState([]);
  const [
    selectedMultiIncorporationRegistration,
    setSelectedMultiIncorporationRegistration,
  ] = useState(null);
  const [openProduction, setOpenProduction] = React.useState(false);
  const [selectedPDFForiegn, setSelectedPDFForiegn] = useState(null);

  const [openRequisiteDocumentsopen, setOpenRequisiteDocumentsopen] =
    React.useState(false);
  const [showForm, setShowForm] = useState(true);
  const [openEachIndividualProducer, setOpenEachIndividualProducer] =
    React.useState(false);
  const [openProductionHouse, setOpenProductionHouse] = React.useState(false);
  const [openOriginalProduction, setOpenOriginalProduction] =
    React.useState(false);
  const [openInformationBroadcasting, setOpenInformationBroadcasting] =
    React.useState(false);
  const [isNoDisabled, setIsNoDisabled] = useState(false);
  const [formData, setformData] = React.useState({
    ott_form_id: id,
    type: "",
    name: "",
    address: "",
    phone: "",
    email: "",
    website: "",
    is_follow_it_rules: "",
    is_original_production: "",
    is_registered: "",
    is_residing_in_country: "",
    incorporation_registration_in_india_multi: "",
    is_incorporation_registration_in_india_multi: "",
    incorporation_registration_in_foreign_multi: "",
    is_incorporation_registration_in_foreign_multi: "",
  });

  const loadData = async () => {
    const preData = await getRequest(`ott/${id}/coproducer`);
    const data = preData.data;

    if (data.length > 0) {
      setFormDataMain({
        ...FormDataMain,
        have_producer: 1,
      });
      setProducerErrors({
        ...errors,
        have_producer: null,
      });
      if (data.length >= 5) {
        setShowForm(false);
      } else {
        setShowForm(true);
      }
      setIsNoDisabled(false);
    } else {
      setFormDataMain({
        ...FormDataMain,
        have_producer: null,
      });
      setIsNoDisabled(true);
    }
    //  if (data && data.length < 5) setShowAddNewEntry(true)
    setPreData(data);
  };
  useEffect(() => {
    loadData();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.ott_form_id) newErrors.ott_form_id = "form id  is missing";
    if (!formData.type) newErrors.type = "Select production type";
    if (!formData.name) newErrors.name = "Enter your name";
    if (!formData.address) newErrors.address = "Enter your address";
    // if (!formData.phone) newErrors.phone = 'Enter your phone number';
    if (formData.phone.length < 10) newErrors.phone = "Enter your phone number";
    // if (!formData.email) newErrors.email = 'Enter your email id';
    if (!formData.email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i))
      newErrors.email = "Invalid email format";
    //if (!formData.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) newErrors.email = 'Enter a valid email ID';

    if (!formData.is_follow_it_rules && formData.type == 1)
      newErrors.is_follow_it_rules = "Select one option";
    if (!formData.is_original_production && formData.type == 1)
      newErrors.is_original_production = "Select one option";
    if (
      formData.is_registered !== 1 &&
      formData.is_registered !== 0 &&
      formData.type == 2
    ) {
      newErrors.is_registered = "Select one option";
    }
    if (
      formData.is_residing_in_country !== 1 &&
      formData.is_residing_in_country !== 0 &&
      formData.type === 3
    ) {
      newErrors.is_residing_in_country = "Select one option";
    }
    console.log({
      type: formData.type,
    });
    let flag = false;
    if (formData.type == 1) {
      if (formData.is_follow_it_rules == 1) {
        if (!formData.is_incorporation_registration_in_india_multi) {
          console.log("pass3 ");
          flag = true;
        }
      }
    } else if (formData.type == 2) {
      console.log("pass1");
      if (formData.is_registered == 1) {
        if (!formData.is_incorporation_registration_in_india_multi) {
          console.log("pass3 ");
          flag = true;
        }
      }
    } else {
      if (formData.is_residing_in_country == 1) {
        if (!formData.is_incorporation_registration_in_india_multi) {
          console.log("pass3 ");
          flag = true;
        }
      }
    }

    if (flag)
      newErrors.incorporation_registration_in_india_multi =
        "Please add a file.";
    // if (
    //   !(
    //     formData.type == 1 &&
    //     formData.is_follow_it_rules == 1 &&
    //     formData.is_incorporation_registration_in_india_multi
    //   ) ||
    //   !(
    //     formData.type == 2 &&
    //     formData.is_registered == 1 &&
    //     formData.is_incorporation_registration_in_india_multi
    //   ) ||
    //   !(
    //     formData.type == 3 &&
    //     formData.is_residing_in_country == 1 &&
    //     formData.is_incorporation_registration_in_india_multi
    //   )
    // ) {
    //   newErrors.incorporation_registration_in_india_multi =
    //     "Please add a file.";
    // }

    if (
      formData.type == 2 &&
      formData.is_registered == 0 &&
      !formData.is_incorporation_registration_in_foreign_multi
    ) {
      newErrors.incorporation_registration_in_foreign_multi =
        "Upload proof in pdf";
    }

    setErrorsForm(newErrors);
    console.log("New Erroer", newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleFormData = (e) => {
    const { name, value } = e.target;

    if (name === "type") {
      if (value == 1) {
      } else if (value == 2) {
      } else if (value == 3) {
      }
    }
    setformData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    errorsForm[name] = "";
    setErrorsForm(errorsForm);

    setformData((prevData) => ({
      ...prevData,
      [name]: name === "phone" ? value.replace(/\D/g, "").slice(0, 10) : value,
    }));

    // const newValue = value.replace(/\D/g, '').slice(0, 10);
    // if (name == "phone") {
    //     setformData(prevData => ({
    //         ...prevData,
    //         [name]: newValue
    //     }));
    // } else {
    //     setformData(prevData => ({
    //         ...prevData,
    //         [name]: value
    //     }));
    // }

    if (name === "email") {
      validateProducerEmail(value);
    }
  };

  const validateProducerEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailRegex.test(email)) {
      setErrorsForm({
        ...errorsForm,
        email: "Invalid email format",
      });
    } else {
      setErrorsForm({
        ...errorsForm,
        email: "",
      });
    }
  };
  const handleReleaseDate = (e) => {
    if (e) {
      const formattedDate = e.format("YYYY-MM-DD");
      setformData((prevData) => ({
        ...prevData,
        stream_date: dayjs(formattedDate),
      }));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    setLoading(true);

    try {
      const response = await postRequest(`ott/${id}/coproducer`, formData);

      if (!response.status) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      // Reset form after submission, preserving the type field
      setformData((prevData) => ({
        ...prevData,
        name: "",
        address: "",
        phone: "",
        email: "",
        website: "",
        is_follow_it_rules: "",
        is_original_production: "",
        is_registered: "",
        is_residing_in_country: "",
        is_incorporation_registration_in_india_multi: null,
        is_incorporation_registration_in_foreign_multi: null,
      }));
      setSelectedMultiIncorporationRegistration({});
      setSelectedPDFForiegn({});
      loadData();
      setAlertMessage("Data has been submitted successfully!");
      setAlertSeverity("success");
      setAlertOpen(true);
    } catch (error) {
      console.error("Error: ", error);
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
  };

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [prepareDelete, setPrepareDelete] = useState(null);

  const handleDeleteOpen = (data, e) => {
    e.preventDefault();

    setPrepareDelete(data);
    setOpenDeleteConfirm(true);
  };

  const handleDeleteClose = (e) => {
    e.preventDefault();
    setOpenDeleteConfirm(false);
  };
  const submitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await deleteRequest(
        `ott/${id}/coproducer/${prepareDelete}`,
        formData
      );

      if (!response.status) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      loadData();
      // alert('Record deleted successfully!');
      setAlertMessage("Data has been deleted successfully!");
      setAlertSeverity("error");
      setAlertOpen(true);
      //  await loadpreData();
    } catch (error) {
      console.error("Error: ", error);
      // alert('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
    setOpenDeleteConfirm(false);
  };

  const handleKeyDown = (event) => {
    // Prevent the letter 'e', '+', '-', '.' and other non-numeric characters
    if (["e", "E", "+", "-", "."].includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleSelectedMultiIncorporationRegistrationIndia = (event) => {
    const selectedFile = event.target.files[0];
    const validateState = validatePdf(selectedFile);
    // alert("check");
    if (!validateState["status"]) {
      setErrorsForm({
        incorporation_registration_in_india_multi: validateState.message,
      });
    } else {
      setSelectedMultiIncorporationRegistration(event.target.files[0]);
      // console.log("incorporation multi registration")
      const profileOfMultiIncorporationRegistration = event.target.files[0];
      // console.log(profileOfMultiIncorporationRegistration);
      // console.log("Selected Director file:", selectedDirectorFile);
      setformData((prevState) => ({
        ...prevState,
        incorporation_registration_in_india_multi:
          profileOfMultiIncorporationRegistration,
        is_incorporation_registration_in_india_multi: 1,
      }));
      setErrorsForm({
        incorporation_registration_in_india_multi: "",
      });
    }
  };

  const handleSelectedForiegn = (event) => {
    const selectedFile = event.target.files[0];
    const validateState = validatePdf(selectedFile);

    if (!validateState["status"]) {
      setErrorsForm({
        incorporation_registration_in_foreign_multi: validateState.message,
      });
    } else {
      setSelectedPDFForiegn(selectedFile);
      setformData((prevState) => ({
        ...prevState,
        incorporation_registration_in_foreign_multi: selectedFile,
        is_incorporation_registration_in_foreign_multi: 1,
      }));
      setErrorsForm({
        incorporation_registration_in_foreign_multi: "",
      });
    }
  };

  const handleRequisiteDocumentsClickOpen = () => {
    setOpenRequisiteDocumentsopen(true);
  };

  const handleCloseProducerMulti = () => {
    // setOpenProducerMulti(false)
  };

  const handleMultiProducer = (e) => {
    const { name, value } = e.target;

    if (value == 1) {
      // setOpenProducerMulti(true);
      setformData({
        ...formData,
        [name]: value,
      });
    } else {
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setErrorsForm(errors);
    }
  };

  // const handleSingleProducer = (e) => {
  //     const { name, value } = e.target;

  //     if (value === 0) {
  //         setOpenProducerSingle(true);
  //         setformData({
  //             ...formData,
  //             [name]: value
  //         })
  //     } else {
  //         setformData({
  //             ...formData,
  //             [name]: parseInt(value),
  //         });
  //         errors[name] = ""
  //         setErrorsForm(errors);
  //     }
  // }

  const handleEachEpisodeSeason = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      // setOpenEachEpisodeDuration(true);
      setformData({
        ...formData,
        [name]: null,
      });
    } else {
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setErrorsForm(errors);
    }
  };

  const handleCloseProductionHouse = () => {
    setOpenProductionHouse(false);
  };

  const handleCloseBroadcasting = () => {
    setOpenInformationBroadcasting(false);
  };

  const handleCloseEachIndividualProducer = () => {
    setOpenEachIndividualProducer(false);
  };

  const handleCloseOriginalProduction = () => {
    setOpenOriginalProduction(false);
  };

  const handleProductionHouse = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      setOpenProductionHouse(true);
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
    } else {
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      // setProducerErrors(errors);
      setErrorsForm(errors);
    }
  };

  const handleInformationBroadcasting = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      setOpenInformationBroadcasting(true);
      setformData({
        ...formData,
        [name]: null,
      });
    } else {
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setErrorsForm(errors);
    }
  };

  const handleOriginalProduction = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      setOpenOriginalProduction(true);
      setformData({
        ...formData,
        [name]: null,
      });
    } else {
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setErrorsForm(errors);
    }
  };

  const handleEachIndividualProducer = (e) => {
    const { name, value } = e.target;

    if (value === 0 || value === "0") {
      setOpenEachIndividualProducer(true);
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
    } else {
      setformData({
        ...formData,
        [name]: parseInt(value),
      });
      errors[name] = "";
      setErrorsForm(errors);
    }
  };
  let placeholdername =
    "(vi.i) Upload proof of the incorporation/registration/ in India";

  if (
    formData.coproducer_type == 3 &&
    formData.coproducer_is_residing_in_country
  ) {
    placeholdername = "(vi.i) Upload proof of the individual in India";
  }

  return (
    <>
      {loading && <Loader />}

      {preData.map((item, index) => (
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <div className="card">
            <div className="card-body" style={{ position: "relative" }}>
              <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                <button
                  className="btn btn-danger"
                  // onClick=
                  // {(event) => submitDelete(item.id, event)}
                  value={item.id}
                  name="handledelete"
                  onClick={(e) => handleDeleteOpen(item.id, e)}
                >
                  <DeleteOutlinedIcon style={{ color: "white" }} />
                </button>

                <DeleteDialog
                  open={openDeleteConfirm}
                  handleClose={handleDeleteClose}
                  handleDelete={submitDelete}
                />
              </div>
              <p>
                Production Type :{" "}
                <b>
                  {item.type == 1 ? (
                    "OTT"
                  ) : item.type == 2 ? (
                    "Production House"
                  ) : item.type == 3 ? (
                    "Individual Producer"
                  ) : (
                    <></>
                  )}
                </b>
              </p>
              <p>
                Name : <b>{item.name}</b>
              </p>
              <p>
                Address : <b>{item.address}</b>
              </p>
              <p>
                Phone : <b>{item.phone}</b>
              </p>
              <p>
                Email : <b>{item.email}</b>
              </p>
              <p>
                Website : <b>{item.website}</b>
              </p>
              {item.type == 1 ? (
                <>
                  <p>
                    Whether the OTT Platform has furnished information under
                    Rule 18 of IT Rules, 2021 to the Ministry of Information and
                    Broadcasting, Government in India :{" "}
                    <b>{item.is_follow_it_rules ? "Yes" : "No"}</b>
                  </p>
                  <p>
                    Whether the web series is its original production :{" "}
                    <b>{item.is_original_production ? "Yes" : "No"}</b>
                  </p>
                </>
              ) : (
                <></>
              )}
              {item.type == 2 && item.is_registered == 1 ? (
                <>
                  <p>
                    Whether the Production House is incorporated/registered in
                    India: <b>{item.is_registered ? "Yes" : "No"}</b>
                  </p>
                </>
              ) : (
                <></>
              )}
              {item.type == 2 && item.is_registered === 0 ? (
                <>
                  <p>
                    Whether the Production House is incorporated/registered in
                    India: <b>{item.is_registered ? "Yes" : "No"}</b>
                  </p>
                  <p>
                    Nationality : <b>{item.nationality}</b>
                  </p>
                </>
              ) : (
                <></>
              )}
              {item.type == 3 && item.is_residing_in_country == 1 ? (
                <>
                  <p>
                    Whether the Individual Producer is normally working and
                    residing in India:{" "}
                    <b>{item.is_residing_in_country ? "Yes" : "No"}</b>
                  </p>
                </>
              ) : (
                <></>
              )}
              {item.type == 3 && item.is_residing_in_country === 0 ? (
                <>
                  <p>
                    Whether the Individual Producer is normally working and
                    residing in India:{" "}
                    <b>{item.is_residing_in_country ? "Yes" : "No"}</b>
                  </p>
                  <p>
                    Nationality : <b>{item.nationality}</b>
                  </p>
                </>
              ) : (
                <></>
              )}
              <p>
                Proof of the incorporation/registration/Individual in India:
                {!item?.documents?.[0] ? (
                  <></>
                ) : (
                  <div>
                    <span className="Attach_Photo_ID">
                      <a
                        href={`${GLOBAL_URL}downloadfile/ott/${item.id}/${item?.documents?.[0].file}`}
                      >
                        {item?.documents?.[0].name}
                      </a>
                    </span>
                  </div>
                )}
              </p>
            </div>
          </div>
        </Grid>
      ))}

      {showForm ? (
        <>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div>
              <h6>
                (c) Please fill information of any one as applicable:{" "}
                <span style={{ color: "red" }}>*</span>
              </h6>

              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type"
                  id="type_one"
                  value="1"
                  checked={formData.type == 1}
                  onChange={handleFormData}
                />
                <label className="form-check-label" htmlFor="type_one">
                  OTT
                </label>
              </div>

              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type"
                  id="type_two"
                  value="2"
                  checked={formData.type == 2}
                  onChange={handleFormData}
                />
                <label className="form-check-label" htmlFor="type_two">
                  Production House(s)
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="type"
                  id="type_three"
                  value="3"
                  checked={formData.type == 3}
                  onChange={handleFormData}
                />
                <label className="form-check-label" htmlFor="type_three">
                  Individual Producer(s)
                </label>
              </div>
              {errorsForm.type && (
                <p className="text-danger">{errorsForm.type}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                className="d-flex justify-content-end"
              >
                <Box className="d-flex align-items-center">
                  <Box></Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                variant="outlined"
                fullWidth
                // placeholder='Name'

                label={
                  <span>
                    (i) Name<span style={{ color: "red" }}>*</span>
                  </span>
                }
                // InputProps={{
                //     style: {
                //         border: "1px solid #1c5768",
                //         borderRadius: "5px",
                //     },
                // }}
                // Other props as needed
                className="input_border"
                name="name"
                value={formData.name}
                onChange={handleFormData}
              />
            </Box>
            {errorsForm.name && (
              <p className="text-danger">{errorsForm.name}</p>
            )}
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            {/* <textarea
                                value={formData.address}
                                class="form-control" onChange={handleFormData} placeholder="Address" id="floatingTextarea2"
                                style={{
                                    height: "100px",
                                    //  border: "1px solid #1c5768", 
                                    borderRadius: "5px"
                                }}
                                name="address">{formData.address}
                            </textarea> */}

            <Box>
              <TextField
                id="address"
                label={
                  <span>
                    (ii) Address<span style={{ color: "red" }}>*</span>
                  </span>
                }
                multiline
                fullWidth
                // maxRows={5}
                name="address"
                value={formData.address}
                onChange={handleFormData}
              />
            </Box>
            {errorsForm.address && (
              <p className="text-danger">{errorsForm.address}</p>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box className="d-flex align-items-center">
              {/* <FormControl
                        
                        style={{ border: "1px solid #1c5768", borderRadius: "5px" }}
                    >
                        <Select
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label', border: "1px solid #1c5768", borderRadius: "5px", }}
                    
                        >
                            <MenuItem value="">
                                +91
                            </MenuItem>
                            <MenuItem value={10}>Ten</MenuItem>
                            <MenuItem value={20}>Twenty</MenuItem>
                            <MenuItem value={30}>Thirty</MenuItem>
                        </Select>
                    </FormControl> */}
              <TextField
                // variant="outlined"
                type="number"
                fullWidth
                // placeholder='Mobile'

                label={
                  <span>
                    (iii) Phone<span style={{ color: "red" }}>*</span>
                  </span>
                }
                // InputProps={{
                //     style: {
                //         border: "1px solid #1c5768",
                //         borderRadius: "5px",
                //     },
                // }}
                className="input_border"
                inputProps={{ maxLength: 10 }}
                name="phone"
                value={formData.phone}
                onChange={handleFormData}
                onKeyDown={handleKeyDown}
              />
            </Box>
            {errorsForm.phone && (
              <p className="text-danger">{errorsForm.phone}</p>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              // variant="outlined"
              fullWidth
              // placeholder='Email ID'

              label={
                <span>
                  (iv) E-mail<span style={{ color: "red" }}>*</span>
                </span>
              }
              // InputProps={{
              //     style: {
              //         border: "1px solid #1c5768",
              //         borderRadius: "5px",
              //     },
              // }}
              className="input_border"
              name="email"
              value={formData.email}
              onChange={handleFormData}
            />
            {errorsForm.email && (
              <p className="text-danger">{errorsForm.email}</p>
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              // variant="outlined"
              fullWidth
              // placeholder='Website'
              label="(v) Website (Optional)"
              // InputProps={{
              //     style: {
              //         border: "1px solid #1c5768",
              //         borderRadius: "5px",
              //     },
              // }}
              value={formData.website}
              name="website"
              onChange={handleFormData}
            />
          </Grid>
          {formData.type == 1 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                  {/* <h6>The OTT platform must have furnished information to the Ministry in accordance
                                                    with Rule 18 of the IT Rules, 2021</h6> */}
                  <h6>
                    (vi) Whether the OTT Platform has furnished information
                    under Rule 18 of IT Rules, 2021 to the Ministry of
                    Information and Broadcasting, Government of India{" "}
                    <span style={{ color: "red" }}>*</span>
                  </h6>

                  <React.Fragment>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_follow_it_rules"
                        id="is_follow_it_rules_yes"
                        value="1"
                        checked={formData.is_follow_it_rules == 1}
                        onChange={handleFormData}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_follow_it_rules_yes"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_follow_it_rules"
                        id="is_follow_it_rules_no"
                        value="0"
                        checked={
                          formData.is_follow_it_rules === 0 ||
                          formData.is_follow_it_rules === "0"
                        }
                        // onChange={handleFormData}
                        onChange={handleInformationBroadcasting}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_follow_it_rules_no"
                      >
                        No
                      </label>
                    </div>
                    {errorsForm.is_follow_it_rules && (
                      <p className="text-danger">
                        {errorsForm.is_follow_it_rules}
                      </p>
                    )}

                    <BootstrapDialog
                      onClose={handleCloseBroadcasting}
                      aria-labelledby="customized-dialog-title"
                      open={openInformationBroadcasting}
                    >
                      <DialogContent dividers>
                        <Typography gutterBottom>
                          OTT Platform should be furnished information under
                          Rule 18 of IT Rules.
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button autoFocus onClick={handleCloseBroadcasting}>
                          Ok
                        </Button>
                      </DialogActions>
                    </BootstrapDialog>
                  </React.Fragment>
                </Box>
              </Grid>
            </>
          ) : (
            <></>
          )}
          {formData.type == 1 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                  <h6>
                    (vii) Whether the web series is its original production{" "}
                    <span style={{ color: "red" }}>*</span>
                  </h6>
                  <React.Fragment>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_original_production"
                        id="is_original_production_yes"
                        value="1"
                        checked={formData.is_original_production == 1}
                        onChange={handleFormData}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_original_production_yes"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_original_production"
                        id="is_original_production_no"
                        value="0"
                        checked={
                          formData.is_original_production === 0 ||
                          formData.is_original_production === "0"
                        }
                        // onChange={handleFormData}
                        onChange={handleOriginalProduction}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_original_production_no"
                      >
                        No
                      </label>
                    </div>
                    {errorsForm.is_original_production && (
                      <p className="text-danger">
                        {errorsForm.is_original_production}
                      </p>
                    )}
                    <BootstrapDialog
                      onClose={handleCloseOriginalProduction}
                      aria-labelledby="customized-dialog-title"
                      open={openOriginalProduction}
                    >
                      <DialogContent dividers>
                        <Typography gutterBottom>
                          Only original production can be submitted.
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          autoFocus
                          onClick={handleCloseOriginalProduction}
                        >
                          Ok
                        </Button>
                      </DialogActions>
                    </BootstrapDialog>
                  </React.Fragment>
                </Box>
              </Grid>
            </>
          ) : (
            <></>
          )}

          {formData.type == 2 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <div>
                  <h6>
                    {" "}
                    (vi) Whether the Production House is incorporated/registered
                    in India
                  </h6>

                  <div>
                    <React.Fragment>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="is_registered"
                          id="is_registered_yes"
                          value="1"
                          checked={formData.is_registered == 1}
                          onChange={handleProductionHouse}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="is_registered_yes"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="is_registered"
                          id="is_registered_no"
                          value="0"
                          disabled={isNoDisabled}
                          checked={
                            formData.is_registered === 0 ||
                            formData.is_registered === "0"
                          }
                          onChange={handleProductionHouse}
                          onClick={handleRequisiteDocumentsClickOpen}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="is_registered_no"
                        >
                          No
                        </label>
                      </div>
                      {errorsForm.is_registered && (
                        <p className="text-danger">
                          {errorsForm.is_registered}
                        </p>
                      )}
                      {/* <BootstrapDialog
                                                        onClose={handleCloseProductionHouse}
                                                        aria-labelledby="customized-dialog-title"
                                                        open={openProductionHouse}
                                                    >
                                                        <DialogContent dividers>
                                                            <Typography gutterBottom>
                                                                Only Production House(s) incorporated/ registered in India can apply
                                                            </Typography>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button autoFocus onClick={handleCloseProductionHouse}>
                                                                Ok
                                                            </Button>
                                                        </DialogActions>
                                                    </BootstrapDialog> */}
                    </React.Fragment>
                  </div>
                </div>
              </Grid>
            </>
          ) : (
            <></>
          )}

          {(formData.type == 1 && formData.is_follow_it_rules == 1) ||
          (formData.type == 2 && formData.is_registered == 1) ||
          (formData.type == 3 && formData.is_residing_in_country) ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={handleSelectedMultiIncorporationRegistrationIndia}
                    style={{ display: "none", width: "100%" }}
                    id="incorporationRegistration"
                    name="incorporation_registration_in_india_multi"
                  />
                  <label
                    htmlFor="fileInput"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <TextField
                      variant="outlined"
                      placeholder={placeholdername}
                      value={
                        selectedMultiIncorporationRegistration
                          ? selectedMultiIncorporationRegistration.name
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                document
                                  .getElementById("incorporationRegistration")
                                  .click()
                              }
                              edge="end"
                            >
                              <AttachFileIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                        style: {
                          // border: "1px solid #1c5768",
                          borderRadius: "5px",
                          height: "108px",
                        },
                      }}
                      fullWidth
                    />
                    {errorsForm.incorporation_registration_in_india_multi && (
                      <p className="text-danger">
                        {errorsForm.incorporation_registration_in_india_multi}
                      </p>
                    )}
                  </label>
                </Box>
              </Grid>
            </>
          ) : (
            <></>
          )}

          {formData.type == 2 && formData.is_registered === 0 && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                  <TextField
                    type="text"
                    fullWidth
                    label="(vi.i) Please mention the country"
                    value={formData.nationality}
                    onChange={handleFormData}
                    className="input_border"
                    name="nationality"
                  />
                  {errorsForm.nationality && (
                    <p className="text-danger">{errorsForm.nationality}</p>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={handleSelectedForiegn}
                    style={{ display: "none" }}
                    id="incorporationForiegnRegistration"
                    name="incorporation_registration_in_foreign_multi"
                  />
                  <TextField
                    variant="outlined"
                    placeholder="(vi.ii) Upload proof of the PDF"
                    value={selectedPDFForiegn ? selectedPDFForiegn.name : ""}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              document
                                .getElementById(
                                  "incorporationForiegnRegistration"
                                )
                                .click()
                            }
                            edge="end"
                          >
                            <AttachFileIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: "5px",
                        height: "108px",
                      },
                    }}
                    fullWidth
                  />
                  {errorsForm.incorporation_registration_in_foreign_multi && (
                    <p className="text-danger">
                      {errorsForm.incorporation_registration_in_foreign_multi}
                    </p>
                  )}
                </Box>
              </Grid>
            </>
          )}

          {formData.type == 3 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <div>
                  <h6>
                    (vi) Whether the Individual Producer is normally working and
                    residing in India
                  </h6>
                  <React.Fragment>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_residing_in_country"
                        id="is_residing_in_country"
                        value="1"
                        checked={formData.is_residing_in_country == 1}
                        onChange={handleFormData}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_residing_in_country_yes"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_residing_in_country"
                        id="is_residing_in_country_no"
                        value="0"
                        disabled={isNoDisabled}
                        checked={
                          formData.is_residing_in_country === 0 ||
                          formData.is_residing_in_country === "0"
                        }
                        // onChange={handleFormData}
                        onChange={handleEachIndividualProducer}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="is_residing_in_country_no"
                      >
                        No
                      </label>
                    </div>

                    {errorsForm.is_residing_in_country && (
                      <p className="text-danger">
                        {errorsForm.is_residing_in_country}
                      </p>
                    )}
                    {/* <BootstrapDialog
                                                onClose={handleCloseEachIndividualProducer}
                                                aria-labelledby="customized-dialog-title"
                                                open={openEachIndividualProducer}
                                            >
                                                <DialogContent dividers>
                                                    <Typography gutterBottom>
                                                        Individual Producer must be an Indian.
                                                    </Typography>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button autoFocus onClick={handleCloseEachIndividualProducer}>
                                                        Ok
                                                    </Button>
                                                </DialogActions>
                                            </BootstrapDialog> */}
                  </React.Fragment>
                </div>
              </Grid>
            </>
          ) : (
            <></>
          )}

          {formData.type == 3 && formData.is_residing_in_country === 0 ? (
            <>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Box>
                  <TextField
                    type="text"
                    fullWidth
                    label="(vi.i) Please mention the country"
                    value={formData.nationality}
                    onChange={handleFormData}
                    className="input_border"
                    name="nationality"
                  />

                  {errorsForm.nationality && (
                    <p className="text-danger">{errorsForm.nationality}</p>
                  )}
                </Box>
              </Grid>
            </>
          ) : (
            <></>
          )}

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box className="d-flex align-items-center justify-content-end">
              <Box>
                <button className="btn btn-success" onClick={submitForm}>
                  Save and Add More
                </button>
                {errors.have_producer && (
                  <p className="text-danger">{errors.have_producer}</p>
                )}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} className="mt-3">
            {/* <Typography className='text-danger text-capitalize'>Note:</Typography> */}
            {/* <Typography className='text-danger text-capitalize'>1.Please Save and Submit The Entries Of Each Type Individually After Filling The Data</Typography> */}
            <Typography className="text-danger">
              Note:&nbsp;The name of the OTT Platform/producer(s)/production
              House(s)/co-producer(s) will be credited as declared in the
              application form. No request for the change of names would be
              entertained at any stage.
            </Typography>
          </Grid>
        </>
      ) : (
        <></>
      )}

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PartialInfo;
